<div class="main-container" *ngIf="!isLoading" data-cy="perio-tooth-summary-main-container">

  <div class="header" data-cy="perio-tooth-summary-header">Tooth Summary</div>
  <i class="material-icons exit-button" (click)="close()" data-cy="perio-tooth-summary-close-button">close</i>

  <div class="summary-section"
       [class.padding-left]="summarySection.paddingLeft"
       [class.border-right]="summarySection.borderRight"
       [class.inline-summary]="summarySection.small"
       *ngFor="let summarySection of summarySections; let i = index"
       [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section'">
    <div class="section-header" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-header'">{{ summarySection.name }}</div>
    <div class="section-table" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-table'">
      <div class="table-headers" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-table-headers'">
        <div class="table-header"
             [class.no-right-border]="j === summarySection.headers.length-1"
             *ngFor="let header of summarySection.headers; let j = index"
             [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-header-' + header.name + '-label'">
          {{ header.name }}
        </div>
      </div>
      <div class="table-secion" *ngFor="let section of summarySection.sections" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-row'">
        <div class="section-value" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-label'">
          {{ section.name }}
        </div>
        <div class="section-value"
             [class.no-right-border]="j === section.values.length-1"
             *ngFor="let sectionValue of section.values; let j = index"
             [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-value-' + j">
          {{ sectionValue }}
        </div>
      </div>
    </div>
  </div>

</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="perio-tooth-summary-loading-spinner">
  <mat-spinner></mat-spinner>
</div>
